import { useQuery, useMutation } from "react-query";
import {
  getAllCustomers,
  createCustomer,
  getCustomer,
  updateCustomer,
  approveCustomer,
  updateCustomerDetails,
} from "../../api/Onboarding/onboarding";

// Self service - get all customers
export const useGetAllCustomers = (options = {}) => {
  return useQuery("getAllCustomers", getAllCustomers, options);
};

// Self service - get specific customer
const useGetCustomer = (customerId, options = {}) => {
  const records = useQuery(
    ["getCustomer", customerId],
    () => getCustomer(customerId),
    options,
  );
  return records;
};

// Self service - save customers draft
const useCreateCustomer = (options = {}) => {
  return useMutation(createCustomer, options);
};

// Self service - update customers draft
const useUpdateCustomer = (options = {}) => {
  return useMutation(updateCustomer, options);
};

const useApproveCustomer = (options = {}) => {
  return useMutation(approveCustomer, options);
};

// Self service - update customers draft
const useUpdateCustomerDetails = (options = {}) => {
  return useMutation(updateCustomer, options);
};

export {
  useCreateCustomer,
  useGetCustomer,
  useUpdateCustomer,
  useApproveCustomer,
  useUpdateCustomerDetails,
};
